import { RouteConfig } from "vue-router";

const cajaChicasSantiagoOF: RouteConfig = {
  path: "/cajaChicasSantiagoOF",
  name: "cajaChicasSantiagoOF",
  component: () => import(/* webpackChunkName: "caja-chicas-santiago-of" */ "@/views/CajaChicasSantiagoOF.vue"),
};

export default cajaChicasSantiagoOF;
